/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Create_From_Template_DescriptionInputs */



/**
* | output |
* | --- |
* | "Pick a template to create a fully pre-configured project. Chats and personas are created automatically." |
*
* @param {Templates_Create_From_Template_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const templates_create_from_template_description = /** @type {((inputs?: Templates_Create_From_Template_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Create_From_Template_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wähle eine Vorlage, um ein vollständig vorkonfiguriertes Projekt zu erstellen. Chats und Personas werden automatisch angelegt.")
	return /** @type {LocalizedString} */ ("Pick a template to create a fully pre-configured project. Chats and personas are created automatically.")
});